import { useState } from 'react';
import { heroChips } from '@/mocks/homeData';

const quickCards = [
  {
    icon: 'ri-user-3-line',
    title: '身份速览',
    body: '热点解说型内容创作者，围绕娱乐资讯做整理与复盘，靠「一句话讲清」出圈。',
    action: '看完整档案',
    href: '#profile',
  },
  {
    icon: 'ri-article-line',
    title: '档案速读',
    stats: [
      { label: '首次活跃', value: '约 2021' },
      { label: '年龄猜测', value: '25–29 岁' },
    ],
    note: '年龄未经本人官方确认',
    action: '核对详情',
    href: '#profile',
  },
  {
    icon: 'ri-fire-line',
    title: '热度参考',
    stat: { value: '89', unit: '/100', label: '近 30 日搜索指数' },
    tone: true,
    action: '看热度榜',
    href: '#trending',
  },
];

export default function Hero() {
  const [kw, setKw] = useState('');
  const [matched, setMatched] = useState('');

  const submit = () => {
    const t = kw.trim();
    if (!t) return;
    const hit = heroChips.find((c) => c.includes(t) || t.includes(c.split('吃瓜捷克')[1] || ''));
    setMatched(hit || '（暂时没有精确命中，可先看下方热度榜）');
  };

  return (
    <section id="top" className="relative border-b border-background-200/80">
      <div className="mx-auto max-w-7xl px-4 md:px-6 pt-14 md:pt-20 pb-12 md:pb-16">
        <div className="max-w-3xl anim-fade">
          <p className="inline-flex items-center gap-2 text-xs text-foreground-600 bg-background-100 border border-background-200 rounded-full px-3 py-1 mb-5">
            <span className="w-1.5 h-1.5 rounded-full bg-accent-500"></span>
            热门人物 · 资料速查工具
          </p>
          <h1 className="font-heading text-3xl md:text-5xl font-semibold leading-snug md:leading-tight tracking-tight text-foreground-950">
            吃瓜捷克，到底是谁？
          </h1>
          <p className="mt-4 md:mt-5 text-foreground-600 text-base md:text-lg leading-relaxed max-w-2xl">
            想弄清吃瓜捷克是谁？这份档案汇总了能公开查证的个人资料、年龄线索、照片物料，以及
            <strong className="text-foreground-800 font-medium">微博抖音</strong>账号动态，
            帮你快速拼出这位热门人物的真实背景与网络踪迹。
          </p>
        </div>

        <div className="mt-10 md:mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4 anim-fade" style={{ animationDelay: '0.15s' }}>
          {quickCards.map((c) => (
            <div
              key={c.title}
              className="rounded-xl border border-background-200 bg-background-50 p-4 md:p-5 flex flex-col"
            >
              <div className="w-9 h-9 rounded-lg flex items-center justify-center bg-primary-100 text-primary-700 text-lg mb-3">
                <i className={c.icon} aria-hidden="true"></i>
              </div>
              <h3 className="text-sm font-medium text-foreground-950">{c.title}</h3>
              {c.body && <p className="mt-1.5 text-xs text-foreground-600 leading-relaxed flex-1">{c.body}</p>}
              {c.stats && (
                <div className="mt-2 flex items-center gap-4 flex-1">
                  {c.stats.map((s) => (
                    <div key={s.label}>
                      <div className="text-xl font-heading font-semibold text-foreground-950">{s.value}</div>
                      <div className="text-[11px] text-foreground-500 mt-0.5">{s.label}</div>
                    </div>
                  ))}
                </div>
              )}
              {c.note && <p className="mt-1 text-[11px] text-foreground-400">{c.note}</p>}
              {c.stat && (
                <div className="mt-1 flex items-end gap-2 flex-1">
                  <span className="text-3xl font-heading font-semibold text-accent-600 leading-none">{c.stat.value}</span>
                  <span className="text-xs text-foreground-500 mb-0.5">{c.stat.unit}</span>
                  <span className="ml-auto self-center text-[11px] text-foreground-500">{c.stat.label}</span>
                </div>
              )}
              <a
                href={c.href}
                className={`mt-3 inline-flex items-center gap-1.5 text-xs font-medium whitespace-nowrap ${
                  c.tone ? 'text-accent-700' : 'text-primary-700'
                }`}
              >
                {c.action}
                <i className="ri-arrow-right-line" aria-hidden="true"></i>
              </a>
            </div>
          ))}

          <div className="rounded-xl border border-background-200 bg-background-50 p-4 md:p-5 flex flex-col">
            <div className="w-9 h-9 rounded-lg flex items-center justify-center bg-secondary-100 text-secondary-800 text-lg mb-3">
              <i className="ri-search-line" aria-hidden="true"></i>
            </div>
            <h3 className="text-sm font-medium text-foreground-950">这里想搜什么</h3>
            <form
              onSubmit={(e) => {
                e.preventDefault();
                submit();
              }}
              className="mt-2.5 flex flex-col gap-2 flex-1"
            >
              <input
                value={kw}
                onChange={(e) => setKw(e.target.value)}
                placeholder="例如：吃瓜捷克年龄"
                aria-label="搜索关键词"
                className="w-full text-sm px-3 py-2 rounded-md bg-background-100 border border-background-200 placeholder:text-foreground-400 outline-none focus:border-primary-300"
              />
              <button
                type="submit"
                className="inline-flex items-center justify-center gap-1.5 text-sm font-medium bg-secondary-500 text-background-50 hover:bg-secondary-600 px-3 py-2 rounded-md whitespace-nowrap"
              >
                去查一下
              </button>
            </form>
            {matched ? (
              <p className="mt-2 text-[11px] text-foreground-500 leading-snug">
                已定位：<span className="text-primary-700 font-medium">{matched}</span>
              </p>
            ) : (
              <p className="mt-2 text-[11px] text-foreground-400 leading-snug">按回车试试，或从右侧热词点选</p>
            )}
          </div>
        </div>

        <div className="mt-8 flex flex-wrap items-center gap-2">
          <span className="text-xs text-foreground-500 mr-1 whitespace-nowrap">大家常搜：</span>
          {heroChips.map((c) => (
            <button
              key={c}
              type="button"
              onClick={() => {
                setKw(c);
                setMatched(`已为你定位到「${c}」相关内容，可下拉查看。`);
              }}
              className="text-xs px-3 py-1.5 rounded-full bg-background-100 border border-background-200 text-foreground-600 hover:border-primary-300 hover:text-primary-700 whitespace-nowrap"
            >
              {c}
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}